export const getStateToShowOnMenu = (allStates, excludedStates) => {
  return allStates.filter((location) => !excludedStates.includes(location))
}
